export function getUserResourceName(
  resource: 'users' | 'non_admin_users' | 'non_viewer_users'
): string {
  return {
    users: 'members',
    non_admin_users: 'non-admin members', // eslint-disable-line camelcase
    non_viewer_users: 'user seats', // eslint-disable-line camelcase
  }[resource]
}
